import { Component, Input } from '@angular/core';
import { AppState } from '../../config/state';
import { PatronProvider } from '../../providers/patron/patron';
import moment from "moment";
/**
 * Generated class for the CoReserveAccountCardComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-reserve-account-card',
  templateUrl: 'co-reserve-account-card.html'
})
export class CoReserveAccountCardComponent {
  @Input() booking;
  text: string;
  clientKeyword: string;
  canCancel: boolean = false;
  constructor(private state: AppState, private patron : PatronProvider) {
    this.clientKeyword = this.state.client.keyword;
  }

  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    // console.log(this.booking)
    this.canCancel = (this.booking.status == 'approved' && moment().isBefore(moment(this.booking.startTime)));
  }
  cancelBooking(booking){
    if (booking.status == 'approved' && moment().isBefore(moment(this.booking.startTime))){
      this.patron.cancelBooking(booking).then(res =>{
        console.log(res);
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-reserve-account-card/co-reserve-account-card.ts